import Assistance from '../models/Assistance';
import User from '../models/User';
import Monitoring from '../models/Monitoring';
import Dials from '../models/Dials';
import Download from '../models/Download';
import ResolutionCenter from '../models/ResolutionCenter';

export default class PortalController {
	/*@ngInject;*/
	constructor($scope, $timeout, $interval, $http, $location, $route, $routeParams, $sce, $window) {
	    var content = window.translations,
            isMobile = (window.isMobile === true) ? true : false,
            faqs,
            assistance,
            dial_colors = window.dial_colors,
            tutorial = window.tutorial,
            tutorial_video = window.tutorial_video,
            customer = window.customer,
            home_address_order = window.home_address_order,
            css_arrow_pos = window.css_arrow_pos,
            monitoring_fields = window.monitoring_fields,
            brandCode = window.brand_code,
            member_id = window.member_id,
            computer_type = (window.computer_type !== undefined) ? window.computer_type : 'pc',
            cpf_number = ['ca_carrefour_br', 'ca_atacadao_br'],
            scrollTime = 0.3,
            scrollDistance = 130,
            resCenter,
            table;

	    $scope.ignore_feature = window.ignore_feature;

        $scope.notification = 0;

        $scope.modal_assist = "";

        /*$scope.monitoring_dial_value = 4;

        setTimeout(()=> {
            $scope.$apply(function() {
                $scope.monitoring_dial_value = 6;
            })
        }, 2000)*/

        $scope.mobile_dashboard_icons = {
            identity_risk: $sce.trustAsHtml('<svg class="icon"><use xlink:href="#dashboard" /></svg>'),
            data_moniotring: $sce.trustAsHtml('<svg class="icon"><use xlink:href="#shield-4" /></svg>'),
            assistance: $sce.trustAsHtml('<svg class="icon"><use xlink:href="#telemarketer" /></svg>'),
            faqs: $sce.trustAsHtml('<svg class="icon"><use xlink:href="#questions-circular-button" /></svg>')
        };

        if (brandCode === 'ea_gma_ch') {
            $scope.mobile_dashboard_icons = {
                identity_risk: $sce.trustAsHtml('<svg class="icon"><use xlink:href="#identity" /></svg>'),
                data_moniotring: $sce.trustAsHtml('<svg class="icon"><use xlink:href="#shield" /></svg>'),
                assistance: $sce.trustAsHtml('<svg class="icon"><use xlink:href="#assistance-2" /></svg>'),
                faqs: $sce.trustAsHtml('<svg class="icon"><use xlink:href="#faqs" /></svg>')
            };
        }

        var assist_modal = $('#modal-assist-info');

        //Scrolling window smoothness
        $('.page-wrapper.canvas').on("mousewheel DOMMouseScroll", function(event){
            event.preventDefault();

            var delta = event.originalEvent.wheelDelta/120 || -event.originalEvent.detail/3;
            var scrollTop = $($window).scrollTop();
            var finalScroll = scrollTop - parseInt(delta*scrollDistance);

            TweenMax.to($window, scrollTime, {
                scrollTo : { y: finalScroll, autoKill:true },
                ease: Power1.easeOut,
                autoKill: true,
                overwrite: 5
            });
        });

        $scope.mailto = (email)=> {
            window.location.href = `mailto:${email}`;
        };

        var iframe = {
            markup: '<div class="mfp-iframe-scaler">'+
                        '<div class="mfp-close"></div>'+
                        '<iframe class="mfp-iframe" frameborder="0" allow="autoplay" allowfullscreen></iframe>'+
                    '</div>',
            patterns: {
                youtube: {
                    index: 'youtube.com/',
                    id: 'v=',
                    src: '//www.youtube.com/embed/%id%?autoplay=1&enablejsapi=1&rel=0&ytp-pause-overlay=0'
                }
            },
            srcAction: 'iframe_src'
        };

        $('.popup-video').magnificPopup({
            type: 'iframe',
            iframe: iframe
        });

        $('.popup-video').click(function () {
            $('#leftMenu').offcanvas('hide');
        });

        $('body').on("keypress keyup blur", 'input[data-input-type="numeric"]', function(event){
            if ((event.which < 48 || event.which > 57)) {
                event.preventDefault();
            }
        });

        $('body').on("keypress", 'input[data-input-type="numeric_phone"]', function(event){
            if ((event.which != 43)) {
                if ((event.which < 48 || event.which > 57)) {
                    event.preventDefault();
                }
            }
        });

        if (tutorial !== false) {
            if (tutorial == 0) {
                $timeout(function () {
                    $.magnificPopup.open({
                        items: {src: tutorial_video},
                        type: 'iframe',
                        iframe: iframe
                    });
                }, 1000);
            }
        }

        $timeout(function() {
            $('.panel-collapse').on('show.bs.collapse', (event)=>{
                var self        = $(event.target),
                    faq_icon    = self.parent('div').find('.panel-title span.faq-icon'),
                    faq_arrow   = self.parent('div').find('.panel-title span.faq-arrow');

                faq_arrow.addClass('up');
                faq_icon.removeClass('fa-plus-circle');
                faq_icon.addClass('fa-minus-circle');
            });

            $('.panel-collapse').on('hide.bs.collapse', (event)=>{
                var self        = $(event.target),
                    faq_icon    = self.parent('div').find('.panel-title span.faq-icon'),
                    faq_arrow   = self.parent('div').find('.panel-title span.faq-arrow');

                faq_arrow.removeClass('up');
                faq_icon.removeClass('fa-minus-circle');
                faq_icon.addClass('fa-plus-circle');
            });
        }, 100);

        this.curr_language = window.curr_language;

        $scope.content = content;

        $scope.cpf_checkbox = false;

        this.monitoring = new Monitoring($http, customer, content, isMobile, $sce, home_address_order, monitoring_fields, member_id);

        $scope.initMobileDataMonitoringPage =()=>{
            $scope.initDashboard();

            var originalPath = $route.current.originalPath;

            if (originalPath == '/data-monitoring') {
                $scope.getMonitoringDetails().then((value)=>{
                    $scope.$apply(function(){
                        $scope.monitor_add_edit_form = value;
                    });
                });
            }

            $timeout(function(){
                var headerHeight = $('#m_header').height() + 20,
                    mBodyMarginTop = parseInt($('.m-body').css('margin-top'));

                //Adjust margin-top if header is too large
                if (headerHeight > mBodyMarginTop) {
                    $('.m-body').css('margin-top', headerHeight + 20);
                }
            }, 100);
        };

        let trackColor = '#9B9B9B',
            trackWidth = 1,
            arcBorder = false,
            arcColor = '#FFFFFF',
            smallDialTrackColor = '#ECECEC';

        if (brandCode == 'ea_gma_ch') {
            trackColor = dial_colors[0];
            trackWidth = 3;
            arcBorder = true;
            arcColor = '#7f9fa9';
            smallDialTrackColor = arcColor;
        }

        $scope.initDashboard =()=> {
            assistance = new Assistance(window.assistance, window.scan_policy);
            faqs = window.faqs;

            $scope.faqs = faqs;
            $scope.assistance = window.assistance;

            for (var i in $scope.faqs) {
                if (typeof $scope.faqs[i].description == 'string') {
                    $scope.faqs[i].description = $sce.trustAsHtml(faqs[i].description);
                }
            }

            if (isMobile) {
                $('html, body').animate({
                    scrollTop	: 0
                }, 0);

                var notificationElem = $('.notification');

                notificationElem.find('.counter').css('background', dial_colors[2]);

                setTimeout(function(){
                    var panelPosition = $('div.panel-body').position(),
                        startOffDistance = panelPosition.top - $(window).scrollTop();

                    if (startOffDistance <= 20) {
                        startOffDistance = 20;
                    }

                    notificationElem.css({
                        'top': startOffDistance + 'px'
                    });

                    $(window).scroll(function(){
                        var distance = panelPosition.top - $(window).scrollTop();

                        if (distance <= 20) {
                            distance = 20;
                        }

                        notificationElem.css({
                            'top': distance + 'px'
                        });
                    });
                }, 500);

                var abs_url = $location.absUrl(),
                    url = abs_url.substring(abs_url.indexOf('?'), abs_url.indexOf('#!/'));

                $scope.url_prefix = url;
            }

			this.dials = new Dials(270, 170, content, dial_colors);
            this.download = new Download($sce, content, window.deviceDisplayCount);
			this.resCenter = new ResolutionCenter(window.resolution_initial_list, content, $sce);

            $scope.request_assistance = this.resCenter.getRequestList();
            $scope.request_assistance_selected_key = 0;

			$scope.risk_level_dial = this.dials.risk_level_dial(
			    window.overallScore.overall,
                window.overallScore.risk,
                trackColor,
                trackWidth,
                arcBorder,
                arcColor
            );

			$scope.monitoring_dial = this.createMonitoringDial(
			    window.assetScores.assetPercent,
                window.assetScores.assetCount
            );

            $scope.personal_dial = this.dials.small_dial(0, 0, smallDialTrackColor);
            $scope.finance_dial = this.dials.small_dial(0, 0, smallDialTrackColor);
            $scope.dark_web_dial = this.dials.small_dial(0, 0, smallDialTrackColor);

            $scope.getIdentityRiskDetails('monitor_load_0', $('#identity-fraud-page'), true, true);

            (function(monitoring) {
                $(document).off('click', 'svg.assist-info');
                $(document).on('click', 'svg.assist-info', function(){
                    var assist_where = $(this).attr('assist-where'),
                        assist_found = $(this).attr('assist-found'),
                        row_id = $(this).attr('assist-row-id');

                    var row = table.row(row_id).data();

                    if (row.help_opened == 0) {
                        row.help_opened = 1;

                        $(this).parents('tr').find('td').css('font-weight', 'normal');

                        var post = {id:row.hit_id};

                        monitoring.updateScanResultSurvive(post);
                    }

                    $scope.$apply(function(){
                        $scope.modal_assist = assistance.create(assist_where, assist_found);
                    });

                    assist_modal.modal('toggle');
                });

                $(document).on('click', '.btn[data-type=_ignore]', function () {
                    var id = parseInt($(this).attr('data-id'));

                    sweetAlert({
                        title: content['identity-fraud-page-ignore-confirm-title'],
                        text: content['identity-fraud-page-ignore-confirm-text'],
                        type: 'warning',
                        showCancelButton: true,
                        cancelButtonText: content['identity-fraud-page-cancel-action'],
                        confirmButtonText: content['identity-fraud-page-ignore-action']
                    }).then((result) => {
                        // force the closing of tooltip to avoid "hanging"
                        $('[data-toggle="tooltip"]').tooltip('hide');

                        if (result.value) {
                            $('#datatable-results').find('tbody').addClass('disabled');
                            return monitoring.ignoreScanRecord({id});
                        }
                        return Promise.reject('Cancelled request.');
                    }).then((result) => {
                        return $scope.getIdentityRiskDetails('monitor_load_0', $('#identity-fraud-page'), true, true);
                    }).then((result) => {
                        $('#datatable-results').find('tbody').removeClass('disabled');
                    }).catch((error) => {
                        $('#datatable-results').find('tbody').removeClass('disabled');
                        console.log(error);
                    });
                });
            })(this.monitoring);

            var details = [
                {
                    icon 		: 'flaticon-dashboard',
                    icon_type   : 'flaticon',
                    title		: $sce.trustAsHtml(content['monitor-step-identity-fraud-page-title']),
                    text		: content['monitor-step-identity-fraud-page-text'],
                    items 		: 4,
                    method		: 'identity-fraud-page'
                },
                {
                    icon 		: 'flaticon-shield-4',
                    icon_type   : 'flaticon',
                    title		: $sce.trustAsHtml(content['monitor-step-monitoring-page-title']),
                    text		: content['monitor-step-monitoring-page-text'],
                    items 		: 2,
                    method		: 'monitoring-page'
                },
                {
                    icon 		: 'flaticon-technology-3',
                    icon_type   : 'flaticon',
                    title		: $sce.trustAsHtml(content['monitor-step-download-page-'+ computer_type +'-title']),
                    text		: content['monitor-step-download-page-'+ computer_type +'-text'],
                    items 		: 4,
                    method		: 'download-page-pc'
                },
                {
                    icon 		: 'flaticon-devices-1',
                    icon_type   : 'flaticon',
                    title		: $sce.trustAsHtml(content['monitor-step-download-page-mobile-title']),
                    text		: content['monitor-step-download-page-mobile-text'],
                    items 		: 4,
                    method		: 'download-page-mobile'
                },
                {
                    icon 		: 'flaticon-telemarketer',
                    icon_type   : 'flaticon',
                    title		: $sce.trustAsHtml(content['monitor-step-identity-assistance-title']),
                    text		: content['monitor-step-identity-assistance-text'],
                    items 		: 0,
                    method		: 'identity-assistance'
                },
                {
                    icon 		: 'flaticon-questions-circular-button',
                    icon_type   : 'flaticon',
                    title		: $sce.trustAsHtml(content['monitor-step-faqs-page-title']),
                    text		: content['monitor-step-faqs-page-text'],
                    items 		: 0,
                    method		: 'faqs-page'
                }
            ];

            if (brandCode == 'ea_generic_ru') {
                for (let i in details) {
                    if (details[i].method == 'identity-assistance') {
                        details[i].icon = `<svg class="flag-icon email-2"><use xlink:href="#email-2" /></svg>`;
                        details[i].icon_type = 'svg';
                    }
                }
            }

            if (brandCode === 'ea_gma_ch') {
                let svg_icon = '';

                for (let i in details) {
                    switch (details[i].method) {
                        case 'identity-fraud-page':
                            svg_icon = 'identity';
                            break;
                        case 'monitoring-page':
                            svg_icon = 'shield';
                            break;
                        case 'download-page-pc':
                            svg_icon = 'laptop-3';
                            break;
                        case 'download-page-mobile':
                            svg_icon = 'mobile-2';
                            break;
                        case 'identity-assistance':
                            svg_icon = 'assistance-2';
                            break;
                        case 'faqs-page':
                            svg_icon = 'faqs';
                            break;
                    }

                    details[i].icon = `<svg class="flag-icon"><use xlink:href="#${svg_icon}" /></svg>`;
                    details[i].icon_type = 'svg';
                }
            }

            $scope.monitoring_details = [];

            if (window.monitoring_pages.length != details.length) {
                for (var index in window.monitoring_pages) {
                    for (let i in details) {
                        if (details[i].method == window.monitoring_pages[index]) {
                            $scope.monitoring_details.push(details[i]);
                        }
                    }
                }
            } else {
                $scope.monitoring_details = details;
            }

            for (var i = 0; i < $scope.monitoring_details.length; i++) {
                $scope.monitoring_details[i].bg_color = 'bg-primary';

                if (i % 2 == 1) {
                    $scope.monitoring_details[i].bg_color = 'bg-primary-over';
                }
            }

            $scope.monitor_add_edit_form = this.monitoring.add_edit_forms();

            $scope.monitor_breakdown = {
                enabled 		: false,
                personal_dial	: ''
            };

            $scope.resolution_center = {
                select_option	: [{name : 'Choose one...'}],
                initial_list 	: this.resCenter.getInitialList(),
                second_list 	: false,
                resolution 		: $sce.trustAsHtml('')
            };

            resCenter = this.resCenter;
        };

		$scope.initMyAccount =()=> {
            var user = new User($http),
                post = {sms : window.sms};

            $('input[name="sms"]').change(function($event) {
                var checked = $(this).prop('checked');

                if (checked) {
                    post.sms = 1;

                    $('span.text-switch').html(content['form-sms-text-on']);
                } else {
                    post.sms = 0;

                    $('span.text-switch').html(content['form-sms-text-off']);
                }
            });

			$scope.edit_profile = ($event)=>{
                var form 			= $($event.target),
                    profile_update 	= true;

                $scope.update_profile_load = true;

                form.find('input').each(function(){
                    var input 		= $(this),
                        input_name	= input.attr('name');

                    if (input_name != 'sms') {
                        post[input_name] = input.val();
                    }
                });

                if (post.phone != "" && post.phone != undefined) {
                	let firstchar = post.phone.charAt(0);

                	if (firstchar !== '+') {
                        profile_update = false;

                        $scope.update_profile_load = false;

                        swal({
                            title: content['error-swal-title'],
                            text: content['error-swal-phone-country-code'],
                            type: 'error'
                        });
					}
				}

                if (post.sms) {
                    if (post.phone == "" || post.phone == undefined) {
                        profile_update = false;

                        $scope.update_profile_load = false;

                        swal({
                            title: content['error-swal-title'],
                            text: content['error-swal-phone-sms'],
                            type: 'error'
                        });
                    }
                }

                if (profile_update) {
                    user.updateProfile(post).then((value) => {
                        $scope.$apply(function () {
                            $scope.update_profile_load = false;
                        });

                        if (value.success) {
                            swal({
                                title: content['success-alert-title'],
                                text: content['success-alert-text'],
                                type: 'success'
                            });
                        }

                        if (!value.success) {
                            swal({
                                title: content['error-swal-title'],
                                text: value.error[0],
                                type: 'error'
                            });
                        }
                    });
                }
			};

            $scope.change_password = ($event)=>{
                var post = {
                        current		: $scope.change_password_current,
                        password 	: $scope.change_password_password,
                        confirm 	: $scope.change_password_confirm
                    },
                    valid = true;

                policies.forEach((value)=> {
                    if (!value.status) {
                        valid = false;
                    }
                });

                if (!valid) {
                    swal({
                        title: content['error-swal-title'],
                        html: content['registration-health-checker-error'],
                        type: 'error'
                    });
                } else {
                    $scope.change_password_load = true;

                    user.changePassword(post).then((value) => {
                        $scope.$apply(function () {
                            $scope.change_password_load = false;
                        });

                        if (value.success) {
                            swal({
                                title: content['change-password-swal-title'],
                                html: "", //content['change-password-swal-text'],
                                type: 'success'
                            }).then(() => {
                                //Once password has been successfully changed, go back to dashboard page
                                $window.location.href = '/user/dashboard';
                            });
                        }

                        if (!value.success) {
                            swal({
                                title: content['error-swal-title'],
                                html: value.error[0],
                                type: 'error'
                            });
                        }
                    });
                }
            };
        };

        var knobs = $('.panel-body.knobs');

        $scope.mtStepColHeight = 0;

        $timeout(function () {
            //$('[data-toggle="popover"]').popover({ trigger: "hover" });

            var numbers = [];

            $('.mt-step-col').each(function(){
                numbers.push($(this).height() + 45);
            });

            var largestNumber = Math.max.apply(Math, numbers);

            $scope.mtStepColHeight = largestNumber;

            $('.mt-step-col').css('height', largestNumber);
        }, 100);

        $scope.$watch('knobsHeight', ()=> {});

        $scope.aliasKeyPressEvent = ($value, $key, $obj)=>{
            var pattern 	= '',
                new_value	= $value,
                form_group 	= $($obj).parents('div.form-group');

            return new Promise((resolve, reject)=>{
                if ($key !== 'Backspace') {
                    switch ($value.length) {
                        case 2:
                            new_value = $value + '/';
                            resolve({success: true, value: new_value});
                            break;

                        case 5:
                            new_value = $value + '/';
                            resolve({success: true, value: new_value});
                            break;
                    }
                } else {
                    resolve(true);
                }

                if (new_value.length >= 10) {
                    pattern	=/^([0-3]{1}[0-9]{1})\/([0-1]{1}[0-9]{1})\/([0-9]{4})$/;

                    if (pattern.test(new_value)) {
                        form_group.addClass('success');
                    } else {
                        form_group.addClass('error');
                    }

                    resolve(false);
                } else {
                    form_group.removeClass('error');
                    form_group.removeClass('success');
                }
            });
        };

        $scope.creditCardExpiry = ($value, $key, $obj)=>{
            var pattern 	= '',
                new_value	= $value,
                form_group 	= $($obj).parents('div.form-group');

            return new Promise((resolve, reject)=>{
                if ($key !== 'Backspace') {
                    switch ($value.length) {
                        case 2:
                            new_value = $value + '/';
                            resolve({success: true, value: new_value});
                            break;
                    }
                } else {
                    resolve(true);
                }

                if (new_value.length >= 7) {
                    pattern	=/^([0-3]{1}[0-9]{1})\/([0-9]{4})$/;

                    if (pattern.test(new_value)) {
                        form_group.addClass('success');
                    } else {
                        form_group.addClass('error');
                    }

                    resolve(false);
                } else {
                    form_group.removeClass('error');
                    form_group.removeClass('success');
                }
            });
        };

        $('#leftMenu').on('show.bs.offcanvas', function() {
            $('body .page-wrapper').bind('touchmove', function(e){
                e.preventDefault();
            });

            $('.page-wrapper').click(function(){
                $('#leftMenu').offcanvas('hide');
            });
        });

        $('#leftMenu').on('hide.bs.offcanvas', function() {
            $('body .page-wrapper').unbind('touchmove');
            $('.page-wrapper').unbind('click');
        });

        $scope.monitor_action = (name, self, ladda_desc)=>{
            var obj 		= $(`#${name}`),
                monitorForm = $('#monitor-form'),
                height 		= obj.height(),
                block 		= (self !== undefined) ? $(self.target).parents('.mt-step-col') : false,
                stepCol;

            monitorForm.find('.monitor-form').each(function(){
                if ($(this).css('display') != 'none' && $(this).attr('id') != name) {
                    stepCol = $(this);
                }
            });

            if (obj.css('display') == 'none') {
                $scope[ladda_desc] = true;

				$('.mt-step-col').each(function(){
					$(this).find('.icon-arrow-down').css({
                        'bottom': 0,
                        'visibility': 'hidden'
					});
				});
			}

            if (obj.css('display') == 'none') {
                if (name == 'identity-fraud-page') {
                    $scope.getIdentityRiskDetails(ladda_desc, obj, block).then((value)=>{
                        stepCol.animate({
                            height 	: "toggle"
                        }, 100, function() {});

                        $scope.scroll_to('monitor-form');
                    });
                }

                if (name == 'monitoring-page') {
                    $scope.getMonitoringDetails().then((v)=>{
                        $scope.$apply(function(){
                            $scope[ladda_desc] = false;

                            $scope.monitor_add_edit_form = v;

							if (block !== false) {
								if (obj.css('display') == 'none') {
									block.find('.icon-arrow-down').css({
                                        'bottom': css_arrow_pos,
										'visibility': 'visible'
									});
								}
							}

                            stepCol.animate({
                                height 	: "toggle"
                            }, 100, function() {});

                            obj.animate({
                                display : 'block',
                                height 	: "toggle"
                            }, 100);

                            $scope.scroll_to('monitor-form');
                        });
                    });
                }

                if (name == 'download-page-pc') {
                    let that 	= this,
                        device 	= window.ua_platform,
                        devices = JSON.parse(window.odp_devices_allowed);

                    this.download.getInstallCount(device).then((value)=>{
                        $scope.$apply(function(){
                            var dpsCount = value.dpsCount;

                            if (window.deviceDisplayCount > 3) {
                                that.download.software[device][0].installs = dpsCount;
                                that.download.software[device][1].installs = (window.deviceDisplayCount - dpsCount);
                            } else {
                                for (var i = 0; i < dpsCount; i++) {
                                    that.download.software[device][i].protected = true;
                                }
                            }

                            $scope.downloads = that.download.setProtectedSoftware(device);

							$scope.download_guide = content['download-'+ computer_type +'-how-to-download-guide'];
							
							$scope[ladda_desc] = false;
							
							if (block !== false) {
								if (obj.css('display') == 'none') {
									block.find('.icon-arrow-down').css({
                                        'bottom': css_arrow_pos,
                                        'visibility': 'visible'
									});
								}
							}
							
							stepCol.animate({
								height 	: "toggle"
							}, 100, function() {});

                            obj.animate({
                                display : 'block',
                                height 	: "toggle"
                            }, 100);
                        });
                    });

                    $scope.scroll_to('monitor-form');
                }

                if (name == 'download-page-mobile') {
                    let that 	= this,
                        device 	= 'mobile';

                    this.download.getInstallCount(device).then((value)=>{
                        $scope.$apply(function(){
                            var mssCount = value.mssCount;

                            if (window.deviceDisplayCount > 3) {
                                that.download.software[device][0].installs = mssCount;
                                that.download.software[device][1].installs = (window.deviceDisplayCount - mssCount);
                            } else {
                                for (var i = 0; i < mssCount; i++) {
                                    that.download.software[device][i].protected = true;
                                }
                            }

                            $scope.downloads = that.download.setProtectedSoftware(device);

                            //$scope.downloads[device].available = (window.deviceDisplayCount - mssCount);

							$scope[ladda_desc] = false;
							
							if (block !== false) {
								if (obj.css('display') == 'none') {
									block.find('.icon-arrow-down').css({
                                        'bottom': css_arrow_pos,
                                        'visibility': 'visible'
									});
								}
							}

                            stepCol.animate({
                                height 	: "toggle"
                            }, 100, function() {});

                            obj.animate({
                                display : 'block',
                                height 	: "toggle"
                            }, 100);
                        });
                    });

                    $scope.scroll_to('monitor-form');
                }

                if (name == 'identity-assistance') {
                    $scope[ladda_desc] = false;

					if (block !== false) {
						if (obj.css('display') == 'none') {
							block.find('.icon-arrow-down').css({
                                'bottom': css_arrow_pos,
                                'visibility': 'visible'
							});
						}
					}

                    stepCol.animate({
                        height 	: "toggle"
                    }, 100, function() {});

                    obj.animate({
                        display : 'block',
                        height 	: "toggle"
                    }, 100);

                    $scope.scroll_to('monitor-form');
                }

                if (name == 'faqs-page') {
                    $scope[ladda_desc] = false;

					if (block !== false) {
						if (obj.css('display') == 'none') {
							block.find('.icon-arrow-down').css({
                                'bottom': css_arrow_pos,
                                'visibility': 'visible'
							});
						}
					}

                    stepCol.animate({
                        height 	: "toggle"
                    }, 100, function() {});

                    obj.animate({
                        display : 'block',
                        height 	: "toggle"
                    }, 100);

                    $scope.scroll_to('monitor-form');
                }
            }
        };

        $scope.delete_monitor_info = (sd_id, p_id, type, $event, monitor_id)=>{
            swal({
                title 				: content['delete-monitor-txt'] + '?',
                type 				: 'warning',
                showCancelButton 	: true,
                confirmButtonText 	: content['delete-monitor-txt'],
                cancelButtonText 	: content['cancel-monitor-txt'],
                confirmButtonColor	: '#10BAEA',
                cancelButtonColor	: '#55585C'
            }).then((willDelete)=>{
                if (willDelete.value === true) {
                    var self = $($event.target).parents('.block'),
                        form_group = $($event.target).parents('.form-group'),
                        post = {
                            data1 : {}
                        };

                    switch (type) {
                        case 'address':
                            post.data1.address = true;
                            post.data1.addr1 = true;
                            post.data1.addr2 = true;
                            post.data1.addr3 = true;
                            post.data1.city = true;
                            post.data1.postcode = true;
                            post.data1.country = true;
                            post.data1['_sd_id-address'] = sd_id;
                            post.data1['_sd_id-addr1'] = sd_id;
                            post.data1['_sd_id-addr2'] = sd_id;
                            post.data1['_sd_id-addr3'] = sd_id;
                            post.data1['_sd_id-city'] = sd_id;
                            post.data1['_sd_id-postcode'] = sd_id;
                            post.data1['_sd_id-country'] = sd_id;
                            post.data1.p_id = p_id;
                            break;

                        case 'cc':
                            post.data1.credit_card = true;
                            post.data1.cc_expiry = true;
                            post.data1['_sd_id-credit_card'] = sd_id;
                            post.data1['_sd_id-cc_expiry'] = sd_id;
                            post.data1.p_id = p_id;
                            break;

                        case 'bank':
                            post.data1.bank_account = true;
                            post.data1.bank_code = true;
                            post.data1['_sd_id-bank_account'] = sd_id;
                            post.data1['_sd_id-bank_code'] = sd_id;
                            post.data1.p_id = p_id;
                            break;

                        case 'social_network':
                            post.data1['no-monitoring'] = 'social_network';
                            post.data1[type] = true;
                            post.data1['_sd_id-' + type] = sd_id;
                            post.data1.p_id = p_id;
                            break;

                        default:
                            post.data1[type] = true;
                            post.data1['_sd_id-' + type] = sd_id;
                            post.data1.p_id = p_id;
                    }

                    this.monitoring.deleteAssetData(post).then((value)=>{
                        if (value.success) {
                            if (type === 'dob') {
                                form_group.removeClass('col-md-5')
                                form_group.addClass('col-md-6')
                                form_group.find('input').val('')
                                form_group.find('svg.dob-delete').remove()
                            }

                            this.monitoring.getAssetData().then((data_value)=>{
                                $scope.$apply(()=>{
                                    $scope.monitor_add_edit_form = data_value.forms;

                                    self.remove();

                                    $scope.monitoring_dial.value = data_value.monitor_details.assetPercent;
                                    $scope.monitoring_dial.options.displayNumber.number = data_value.monitor_details.assetCount;

                                    $scope.risk_level_dial.value = data_value.risk_details.overall_score;

                                    let properties = this.dials.set_dial_properties(data_value.risk_details.overall_risk),
                                        colors 		= ['#FFFFFF', '#FFFFFF', '#FFFFFF'];

                                    for (var i = 0; i <= properties.index; i++) {
                                        colors[i] = dial_colors[i];
                                    }

                                    $scope.risk_level_dial.options.displayDanger.text = content[`risk-level-dial-txt-${data_value.risk_details.overall_risk}`].toUpperCase();
                                    $scope.risk_level_dial.options.displayDanger.colors = colors;

                                    delete $scope.monitor_add_edit_form[monitor_id].fields[sd_id];
                                });
                            });
                        }
                    });
                }
            });
        };

        $scope.monitor_save_continue = (obj, next_id)=>{
            var self = $(obj.target),
                form = self.parents('form');

            $scope.monitor_save(form, next_id);
        };

        $scope.monitor_save_cpf_number = (obj, action)=>{
            var self = $(obj.target),
                form = self.parents('form');

            $scope.cpf_checkbox = action ? false : true;

            $scope.monitor_save(form);
        };

        $scope.monitor_save = (obj, next_id = false)=>{
            var self = obj;

            if (typeof obj.target === 'object') {
                self = $(obj.target);

                $scope.modal_save_btn = true;
            } else {
                $scope.modal_save_continue_btn = true;
            }

            var groups			= self.find('.group'),
                input_values	= {
                    add 	: {},
                    edit 	: {}
                },
                save_process = {
                    count 	: 0,
                    details : {}
                },
                modal 			= $('#modal-monitor-add-edit');

            groups.each(function(e){
                var index 	= e += 1,
                    fields	= $(this).find('input'),
                    labels 	= $(this).find('input[label=true]'),
                    label	= $(this).find('input[name=_label]'),
                    type	= ($(this).attr('class').indexOf('add') !== -1) ? 'add' : 'edit',
                    sd_id 	= $(this).find('input[name=sd_id]').val();

                fields.each(function(e){
                    var input 		= $(this),
                        value 		= input.val(),
                        input_name 	= input.attr('name'),
                        data 		= `data${index}`,
                        sd_id_name	= `_sd_id-${input_name}`;

                    if (input.attr('readonly') === undefined) {
                        if (input_values[type][data] === undefined) {
                            input_values[type][data] = {};
                        }

                        if ((input_name != '_label') && (input_name != 'sd_id')) {
                            if (value !== 'undefined' && value !== '') {
                                input_values[type][data][input_name] = value;

                                if (input_name === 'email') {
                                    input_values[type][data]['isValid'] = /\S+@\S+\.\S+/.test(value)
                                }
                            }
                        }

                        if ((type == 'edit') && (input_name != '_label') && (input_name != '_label-dob') && (input_name != 'sd_id')) {
                            input_values.edit[data][sd_id_name] = sd_id;
                        }

                        if (input_name === 'cpf_checkbox') {
                            input_values.add[data]['_label-passport'] = 'CPF Number';
                            input_values.add[data][sd_id_name] = sd_id;
                        }
                    }
                });

                labels.each(function(e){
                    var input 		= $(this),
                        value 		= input.val(),
                        input_name 	= input.attr('name'),
                        data 		= `data${index}`,
                        label_tag	= `_label-${input_name}`;

                    if (value !== 'undefined' && value !== '') {
                        input_values[type][data][label_tag] = label.val();
                    }
                });
            });

            var isLabelEmpty = false;

            for (let i in input_values.add) {
                let addFields = input_values.add[i];

                if (!$scope.isEmpty(addFields)) {
                    for (let a in addFields) {
                        if (a.indexOf('_label') !== -1) {
                            if (addFields[a].length === 0) {
                                isLabelEmpty = true;
                            }
                        }
                    }
                }
            }

            for (let i in input_values.edit) {
                let editFields = input_values.edit[i];

                console.log('Edit fields - ', editFields)

                if (!$scope.isEmpty(editFields)) {
                    for (let a in editFields) {
                        if (a.indexOf('_label') !== -1) {
                            if (editFields[a].length === 0) {
                                isLabelEmpty = true;
                            }
                        }
                    }
                }
            }

            if (isLabelEmpty) {
                var options = {
                    title 	: content['error-label-empty'],
                    type 	: 'error',
                    delay 	: 2000
                };

                $scope.show_swal_modal(options).then((value)=>{
                    $scope.$apply(()=>{
                        $scope.modal_save_btn = false;
                        $scope.modal_save_continue_btn = false;
                    });
                });
            } else {
                let isEmailValid = true

                Object.keys(input_values.add).forEach((key)=>{
                    if (input_values.add[key].isValid !== undefined && input_values.add[key].isValid === false) {
                        isEmailValid = false
                    }
                });

                Object.keys(input_values.edit).forEach((key)=>{
                    if (input_values.edit[key].isValid !== undefined && input_values.edit[key].isValid === false) {
                        isEmailValid = false
                    }
                });

                if (!isEmailValid) {
                    var options = {
                        title 	: content['invalid-email'],
                        type 	: 'error',
                        delay 	: 2000
                    };

                    $scope.show_swal_modal(options).then((value)=>{
                        $scope.$apply(()=>{
                            $scope.modal_save_btn = false;
                            $scope.modal_save_continue_btn = false;
                        });
                    });
                } else {
                    if (!$scope.isEmpty(input_values.add.data1)) {
                        for (var i in input_values.add) {
                            if (input_values.add[i].cpf_checkbox !== undefined) {
                                input_values.add[i].cpf_checkbox = $scope.cpf_checkbox ? 'ON' : 'OFF';
                            }
                        }

                        this.monitoring.addAssetData(input_values.add).then((value) => {
                            save_process.count += 1;

                            if (save_process.count == 2) {
                                save_process.count = 0;

                                var options = {
                                    title: content['success-label-saved'],
                                    type: 'success',
                                    delay: 2000
                                };

                                $scope.show_swal_modal(options).then((value) => {
                                    if (next_id !== false) {
                                        this.monitoring.getAssetData().then((data_value) => {
                                            $scope.$apply(()=> {
                                                $scope.monitor_add_edit_form = data_value.forms;

                                                $scope.monitoring_dial.value = data_value.monitor_details.assetPercent;
                                                $scope.monitoring_dial.options.displayNumber.number = data_value.monitor_details.assetCount;

                                                $scope.id_monitor_add_edit(next_id, 'add');
                                            });
                                        });
                                    } else {
                                        this.monitoring.getAssetData().then((data_value) => {
                                            $scope.$apply(()=> {
                                                $scope.monitoring_dial.value = data_value.monitor_details.assetPercent;
                                                $scope.monitoring_dial.options.displayNumber.number = data_value.monitor_details.assetCount;

                                                $scope.monitor_add_edit_form = data_value.forms;
                                            });
                                        });

                                        modal.modal('toggle');
                                    }
                                });

                                $scope.$apply(() => {
                                    $scope.modal_save_btn = false;
                                    $scope.modal_save_continue_btn = false;
                                });
                            }
                        });
                    } else {
                        save_process.count += 1;
                    }

                    this.monitoring.updateAssetData(input_values.edit).then((value) => {
                        $scope.$apply(() => {
                            $scope.modal_save_btn = false;
                        });

                        if (value !== false) {

                        }

                        save_process.count += 1;

                        if (save_process.count == 2) {
                            save_process.count = 0;

                            var options = {
                                title: content['success-label-saved'],
                                type: 'success',
                                delay: 2000
                            };

                            $scope.show_swal_modal(options).then((value) => {
                                if (next_id !== false) {
                                    this.monitoring.getAssetData().then((data_value) => {
                                        $scope.$apply(function () {
                                            $scope.monitor_add_edit_form = data_value.forms;

                                            $scope.monitoring_dial.value = data_value.monitor_details.assetPercent;
                                            $scope.monitoring_dial.options.displayNumber.number = data_value.monitor_details.assetCount;

                                            $scope.id_monitor_add_edit(next_id, 'add');
                                        });
                                    });
                                } else {
                                    this.monitoring.getAssetData().then((data_value) => {
                                        $scope.$apply(function () {
                                            $scope.monitor_add_edit_form = data_value.forms;

                                            console.log('Is it coming here next id is false')

                                            $scope.monitoring_dial.value = data_value.monitor_details.assetPercent;
                                            $scope.monitoring_dial.options.displayNumber.number = data_value.monitor_details.assetCount;
                                        });
                                    });

                                    modal.modal('toggle');
                                }
                            });

                            $scope.$apply(() => {
                                $scope.modal_save_btn = false;
                                $scope.modal_save_continue_btn = false;
                            });
                        }
                    });
                }
            }
        };

        $scope.show_swal_modal = (options)=> {
            return new Promise((resolve, reject)=>{
                swal({
                    title 				: options.title,
                    type 				: options.type,
                    showConfirmButton	: false,
                    timer				: options.delay
                }).then((result)=>{
                    resolve(true);
                });
            });
        };

        $scope.isEmpty = (obj)=>{
            for (var key in obj) {
                if(obj.hasOwnProperty(key)) {
                    return false;
                }
            }

            return true;
        };

        $scope.isChanged = (arr)=>{

        };

        $scope.monitor_skip = (index, type)=>{
            if (this.monitoring.add_edit_forms(index) === undefined) {
                index = 0;
            }

            $scope.id_monitor_add_edit(index, type);
        };

        $scope.id_monitor_add_edit = (index, type)=>{
            var modal 		= $('#modal-monitor-add-edit'),
                form 		= this.monitoring.add_edit_forms(index),
                //name_title 	= (type == 'add') ? `${content['data-monitoring-page-prefix-add']} ${form.name}` : `${content['data-monitoring-page-prefix-edit']} ${form.name}`,
                name_title	= form.name,
                fields 		= $scope.monitor_add_edit_form[index].fields;

            $scope.modal_monitor_form = {
                id 			: index,
                title 		: name_title,
                details 	: form,
                html 		: $sce.trustAsHtml(this.monitoring[form.alias](fields))
            };

            modal.modal();

            $timeout(function () {
                if (jQuery().datepicker) {
                    $('.date-picker').datepicker({
                        autoclose: true
                    });
                }
            }, 100);

            //$('.date-picker').datepicker();
        };

        $scope.modal_close = ()=>{
            var modal = $('#modal-monitor-add-edit');

            modal.modal('toggle');
        };

        $scope.send_request_form = ($event)=> {
            var form 	= $($event.target).parents('#modal-monitor-request-assistance').find('form'),
                option 	= $('.requestAssistanceForm option:selected'),
                value 	= option.attr('value'),
                modal 	= $('#modal-monitor-request-assistance'),
                post	= {};

            post.request_type = value;

            form.find('input').each(function(){
                var name  = $(this).attr('name'),
                    value = $(this).val();

                post[name] = value;
            });

            post.comments = form.find('textarea').val();

            $scope.submit_request_button = true;

            this.resCenter.requestCallPost(post).then((value)=>{
                $timeout(function(){
                    $scope.submit_request_button = false;
                }, 100);

                if (value.success) {
                    swal({
                        title 		: content['request-assistance-swal-title'],
                        text 		: content['request-assistance-swal-text'],
                        type 		: 'success'
                    }).then((value)=>{
                        modal.modal('toggle');
                    });
                }
            });
        };

        $('#request_assistance').on("change", function(e) {
            var option 	= $('#request_assistance option:selected'),
                key 	= option.attr('key'),
                value 	= option.attr('value'),
                modal 	= $('#modal-monitor-request-assistance');

            $scope.$apply(function(){
                $scope.request_assistance_selected_key = key;
            });

            modal.modal('toggle');
        });

        $('#res_center_initial').on("change", function(e) {
            var option 			= $("#res_center_initial option:selected"),
                //option_selected	= $scope.resolution_center.initial_list[option.attr('key')],
                article_id 		= option.attr('article_id');

            resCenter.getArticle(article_id).then((value)=>{
                $scope.$apply(function(){
                    $scope.article = $sce.trustAsHtml(value.article);
                });

                resCenter.getGroupById(value.resolution_group_id).then((group_value)=>{
                    $scope.$apply(function(){
                        $scope.resolution_group = group_value;
                    });
                });
            });
        });

        $('#res_center_second').on("change", function(e) {
            var option 			= $("#res_center_initial option:selected"),
                option_selected	= $scope.resolution_center.second_list.list[option.attr('key')];

            $scope.resolution_center.second_list.second_alias = option_selected.alias;

            resCenter.getArticle(option_selected.article_id).then((value)=>{
                $scope.$apply(function(){
                    $scope.article = $sce.trustAsHtml(value.article);
                });

                resCenter.getGroupById(value.resolution_group_id).then((group_value)=>{
                    $scope.$apply(function(){
                        $scope.resolution_group = group_value;
                    });
                });
            });
        });

        $('#res_center_resolution').on("change", function(e) {
            var option = $("#res_center_resolution option:selected");

            resCenter.getArticle(option.val()).then((value)=>{
                $scope.$apply(function(){
                    $scope.resolution_center.resolution = $sce.trustAsHtml(value.article);
                });
            });
        });

        $scope.menuClickedItem = ($event)=>{
            var link = $($event.target).parents('li').find('a').attr('href');

            $window.location.href = link;
        };

        $scope.gotoResCenter = ()=>{
            var second_list = $scope.resolution_center.second_list;

            $window.location.href = `/user/resolution-center/${second_list.initial_alias}/${second_list.second_alias}`;
        };

        $scope.downloadSoftware =()=>{
            $window.location.href = '/user/download-odp';
        };

        $scope.scroll_to = (anchor)=>{
            var section		= $('#'+ anchor),
                position 	= section.offset().top;

            $('html, body').animate({
                scrollTop	: position - $scope.mtStepColHeight
            }, 200);
        };

        $scope.getMonitoringDetails = () =>{
            return new Promise((resolve, reject)=>{
                this.monitoring.getAssetData().then((value)=>{
                    let forms = value.forms;

                    this.monitoring.forms.forEach((forms)=>{
                        if (value.alias === 'cpf_number') {
                            if (parseInt(forms.fields.length) > 0) {
                                $scope.$apply(function() {
                                    $scope.cpf_checkbox = true;
                                });
                            }
                        }
                    });

                    resolve(value.forms);
                });
            });
        };

        $scope.getIdentityRiskDetails = (ladda_desc, obj, block, initial_load)=>{
            return new Promise((resolve, reject)=>{
                this.monitoring.getIdentityRiskDetails().then((value)=>{
                    $scope.personal_dial = this.dials.small_dial(value.scores.personal, value.scores.personalRisk, smallDialTrackColor);
                    $scope.finance_dial = this.dials.small_dial(value.scores.financial, value.scores.financialRisk, smallDialTrackColor);
                    $scope.dark_web_dial = this.dials.small_dial(value.scores.darkweb, value.scores.darkwebRisk, smallDialTrackColor);
                    $scope.risk_level_dial = this.dials.risk_level_dial(value.scores.overall, value.scores.overallRisk);

                    $scope.$apply(function(){
                        $scope[ladda_desc] = false;

						if (block !== false) {
							if (obj.css('display') == 'none') {
								block.find('.icon-arrow-down').css({
                                    'bottom' : css_arrow_pos,
									'visibility': 'visible'
								});
							}
						}

						if (initial_load !== true) {
							obj.animate({
								display : 'block',
								height 	: "toggle"
							}, 100);
						} else {
							$('.col-md-2:nth-child(1)').find('.icon-arrow-down').css({
                                'bottom' : css_arrow_pos,
                                'visibility': 'visible'
                        	});
						}

                        $scope.monitor_table = value.hits;

						var alerts = 0;

						value.hits.forEach((hit)=>{
						    if (hit.help_opened == 0) {
						        alerts += 1;
                            }
                        });

						$scope.notification = alerts;

                        var columns = [
                                { data: "hit_id" },
                                { data: "online_address" },
                                { data: "help" },
                                { data: "where" },
                                { data: "found" },
                                { data: "match" },
                                { data: "date" },
                                { data: "risk" },
                            ],
                            columnDefs = [];

                        if ($scope.ignore_feature) {
                            columns.push({data: "actions"});
                        }

                        columns.push({ data: "help_opened" });

                        for (var i in columns) {
                            switch (columns[i].data) {
                                case 'help_opened':
                                    columnDefs.push({
                                        targets     : [parseInt(i)],
                                        searchable  : false,
                                        orderable 	: false,
                                        visible     : false,
                                        render      : function(data, type, row, meta) {
                                            return data;
                                        }
                                    });
                                    break;

                                case 'hit_id':
                                    columnDefs.push({
                                        targets     : [parseInt(i)],
                                        searchable  : true,
                                        orderable 	: false,
                                        visible     : true,
                                        render 		: function(data, type, row, meta) {
                                            return data;
                                        }
                                    });
                                    break;

                                case 'online_address':
                                    columnDefs.push({
                                        targets: [parseInt(i)],
                                        visible: true,
                                        searchable: true,
                                        render: function (data, type, row, meta) {
                                            if (data !== null && data !== undefined) {
                                                if (window.innerWidth < 500) {
                                                    return data.substring(0, 25) + '...';
                                                }
                                            }

                                            let data_link = data;

                                            if (row.where == 'publicweb') {
                                                data_link = `<a href="${data}" target="_blank" style="text-decoration: underline;">${data}</a>`;
                                            }

                                            return data_link;
                                        }
                                    });
                                    break;

                                case 'help':
                                    columnDefs.push({
                                        targets: [parseInt(i)],
                                        visible: true,
                                        searchable: false,
                                        orderable 	: false,
                                        render: function (data, type, row, meta) {
                                                let where = (row.where !== 'publicweb') ? 'darkweb' : 'publicweb';

                                                return `<svg width="50" style="left: 50%; transform: translate(-50%, -50%);" assist-row-id="${meta.row}" assist-where="${where}" assist-found="${row.found}" class="assist-info"><use xlink:href="#info-2" /></svg>`;
                                            }
                                        });
                                    break;

                                case 'where':
                                    columnDefs.push({
                                        targets     : [parseInt(i)],
                                        visible     : true,
                                        searchable 	: true,
                                        render 		: function(data, type, row, meta) {
                                            var $data = 'Public Web';

                                            if (data !== 'publicweb') {
                                                $data = content['identity-page-dark-web-text'];
                                            }

                                            return $data;
                                        }
                                    });
                                    break;

                                case 'found':
                                    columnDefs.push({
                                        targets     : [parseInt(i)],
                                        visible     : true,
                                        searchable 	: true,
                                        render 		: function(data, type, row, meta) {
                                            var $data = data;

                                            switch (data) {
                                                case 'email':
                                                    $data = content['data-monitoring-page-circle-name-email'];
                                                    break;
                                                case 'credit_card':
                                                    $data = content['data-monitoring-page-circle-name-credit-card'];
                                                    break;
                                                case 'address':
                                                    $data = content['data-monitoring-page-circle-name-address'];
                                                    break;
                                                case 'dob':
                                                    $data = content['data-entry-form-dob'];
                                                    break;
                                                case 'phone':
                                                    $data = content['data-monitoring-page-circle-name-landline'];
                                                    break;
                                                case 'bank_account bank_code':
                                                    $data = content['data-monitoring-page-circle-name-bank'];
                                                    break;
                                                case 'mobile':
                                                    $data = content['data-monitoring-page-circle-name-mobile'];
                                                    break;
                                                case 'driving_license':
                                                    $data = content['data-monitoring-page-circle-name-driver-license'];
                                                    break;
                                                case 'passport':
                                                    $data = content['data-monitoring-page-circle-name-passport'];
                                                    break;
                                                case 'id_card':
                                                    $data = content['data-monitoring-page-circle-name-ni'];
                                                    break;
                                                case 'ebay':
                                                    $data = content['data-monitoring-page-circle-name-ebay'];
                                                    break;
                                                case 'paypal':
                                                    $data = content['data-monitoring-page-circle-name-paypal'];
                                                    break;
                                                case 'iban bic':
                                                    //$data = content['data-monitoring-page-circle-name-email'];
                                                    break;
                                            }

                                            return $data;
                                        }
                                    });
                                    break;

                                case 'date':
                                    columnDefs.push({
                                        targets     : [parseInt(i)],
                                        visible     : true,
                                        searchable 	: true,
                                        type        : 'date', // as seen on https://datatables.net/reference/option/columns.type
                                        render 		: function(data, type, row, meta) {
                                            var d = new Date(data),
                                                month = '' + (d.getMonth() + 1),
                                                day = '' + d.getDate(),
                                                year = d.getFullYear();

                                            if (month.length < 2) month = '0' + month;
                                            if (day.length < 2) day = '0' + day;

                                            return year + '-' + month + '-' + day;
                                        }
                                    });
                                    break;

                                case 'risk':
                                    columnDefs.push({
                                        targets     : [parseInt(i)],
                                        visible     : true,
                                        searchable 	: true,
                                        render 		: function(data, type, row, meta) {
                                            return content['risk-level-dial-txt-' + data].toUpperCase();
                                        }
                                    });
                                    break;

                                case 'actions':
                                    columnDefs.push({
                                        targets     : [parseInt(i)],
                                        visible     : true,
                                        sortable    : false,
                                        searchable  : false,
                                        render      : function(data, type, row, meta) {
                                            return `<div class="text-center">
                                                        <button
                                                            data-id="${row.hit_id}"
                                                            data-type="_ignore"
                                                            data-toggle="tooltip"
                                                            data-placement="top" 
                                                            class="btn btn-danger btn-sm"
                                                            title="${content['identity-fraud-page-ignore-action']}"
                                                         >
                                                            <i class="fa fa-eye-slash"></i>
                                                        </button>
                                                    </div>`;
                                        }
                                    });
                                    break;
                            }
                        }

                        table = $('#datatable-results').DataTable({
                            data 		: value.hits,
                            columns 	: columns,
                            columnDefs	: columnDefs,
                            responsive 	: true,
                            destroy     : true,
                            order       : [[0, "desc"]],
                            language 	: {
                                search 		: content['identity-fraud-page-table-search'],
                                info 		: content['identity-fraud-page-table-show'] + content['identity-fraud-page-table-show-start-end-total'],
                                lengthMenu 	: content['identity-fraud-page-table-show'] + " _MENU_ " + content['identity-fraud-page-table-entries'],
                                infoEmpty 	: `${content['identity-fraud-page-table-show']} ${content['identity-fraud-page-table-show-start-end-total-0']} ${content['identity-fraud-page-table-entries']}  `,
                                emptyTable 	: content['identity-fraud-page-table-empty'],
                                infoFiltered: content['identity-fraud-page-table-filtered'] ? content['identity-fraud-page-table-filtered'] : "(filtered from _MAX_ total entries)",
                                paginate 	: {
                                    next 		: content['identity-fraud-page-table-next'],
                                    previous	: content['identity-fraud-page-table-previous']
                                }
                            },
                            createdRow	: function(row, data, index) {
                                var risk_row = $('td', row).eq(7);

                                risk_row.addClass('text-center');
                                risk_row.addClass('font-white');
                                risk_row.addClass('danger-' + data.risk);

                                if (data.help_opened == 0) {
                                    $('td', row).css('font-weight', 'bold');
                                }
                            }
                        });

                        $.fn.dataTable.ext.errMode = 'none';

                        resolve(value);
                    });
                });
            });
        };
    }

    createMonitoringDial(assetPercent, assetCount) {
        let trackColor = '#9B9B9B',
            trackWidth = 1,
            arcBorder = false,
            arcColor = '#FFFFFF',
            smallDialTrackColor = '#ECECEC';

        if (window.brand_code == 'ea_gma_ch') {
            trackColor = dial_colors[0];
            trackWidth = 3;
            arcBorder = true;
            arcColor = '#7f9fa9';
            smallDialTrackColor = arcColor;
        }

        return this.dials.monitoring_dial(
            assetPercent,
            assetCount,
            window.monitor_bar_color,
            trackColor,
            trackWidth,
            arcBorder,
            arcColor
        );
    }
}
